import { LandingPoposedToTheSubCommitteeContainer } from "../../../containers/borrowSystem/ProposedToTheSubCommittee/LandingPoposedToTheSubCommitteeContainer";
export function LandingPoposedToTheSubCommitteePage () {

    return(
        <LandingPoposedToTheSubCommitteeContainer/>
    )
}




